import React from "react";

import AdminTable from "@Clubhouse/components/Index/components/AdminTable";
import CoachTable from "@Clubhouse/components/Index/components/CoachTable";

import { useAppSelector } from "../../../../hooks/reduxHooks";
import { AUTH_LEVELS } from "../../../../lib/globals";
import ClubhouseDownload from "./components/ClubhouseDownload";
import ClubhouseFilters from "./components/ClubhouseFilters";
import { IndexProvider } from "./contexts/Index";

const ClubhouseIndex = (): React.JSX.Element => {
    const { user } = useAppSelector(state => state.auth);

    return (
        <IndexProvider>
            {user && AUTH_LEVELS.leaguemanagement.includes(user.userLevel) && (
                <ClubhouseFilters />
            )}

            <ClubhouseDownload />

            {user && (user.userLevel <= 2 ? <AdminTable /> : <CoachTable />)}
        </IndexProvider>
    );
};

export default ClubhouseIndex;
